module.exports = __webpack_public_path__ + "img/home-saude.2909118f.svg";